import { authFetch } from './api'

// Inicia el checkout de Stripe (prueba de 14 días con tarjeta) y redirige a la
// URL de Stripe. Usado por el TrialWall (card-wall en acciones de valor) y
// reutilizable desde Pricing/Billing. Lanza si el backend no devuelve url.
export async function startTrialCheckout(plan = 'growth') {
  const res = await authFetch('/api/stripe/checkout', { method: 'POST', body: { plan } })
  const data = await res.json().catch(() => ({}))
  if (data?.error) throw new Error(data.error)
  if (data?.url) {
    window.location.href = data.url
    return
  }
  throw new Error('No pudimos iniciar la prueba. Reintenta en unos segundos.')
}
